// External Dependencies:
import axios from 'axios'

// Redux:
import { awardBadge } from 'actions/site'

export function requestVersesData() {
	return {
		type: 'REQUEST_VERSES_DATA'
	}
}

export function receiveVersesData( data ) {
	return {
		type: 'RECEIVE_VERSES_DATA',
		payload: data
	}
}

export function getVersesData( dateString, single = false ) {
	return function( dispatch, getState ) {
		const { verses } = getState().votd

		if ( verses && verses[ dateString ] ) {
			return
		}

		dispatch( requestVersesData() )

		return axios({
				url: `${siteData.api_base_url}votd?date=${dateString}&single=${single}`,
				timeout: 20000,
				method: 'get',
				responseType: 'json'
			})
			.then( response => {
				dispatch( receiveVersesData( response.data ) )
			})
			.catch( error => {
				console.error( error )
			})
	}
}

export function sendVersesRecording( blob, extension, name, email, date ) {
	return function( dispatch ) {
		const formData = new FormData()
		const nameForFileName = name.replace( /[^a-z0-9]/gi, '_' ) // Sanitize.

		formData.append( 'audio', blob, `${date}-${nameForFileName}.${extension}` )
		formData.append( 'name', name )
		formData.append( 'email', email )
		formData.append( 'date', date )

		return axios({
				url: siteData.api_base_url + 'votd-recording',
				timeout: 20000,
				method: 'post',
				responseType: 'json',
				headers: {
					'content-type': 'multipart/form-data'
				},
				data: formData
			})
			.then( response => {
				dispatch( awardBadge( 'record_votd' ) )
			})
			.catch( error => {
				console.error( error )
			})
	}
}

export function requestScheduledVersesData() {
	return {
		type: 'REQUEST_SCHEDULED_VERSES_DATA'
	}
}

export function receiveScheduledVersesData( date, data ) {
	return {
		type: 'RECEIVE_SCHEDULED_VERSES_DATA',
		payload: {
			date,
			data
		}
	}
}

export function getScheduledVersesData( date ) {
	return function( dispatch, getState ) {
		let { siteId } = getState().schedule

		if ( ! siteId ) {
			siteId = 'default'
		}

		dispatch( requestScheduledVersesData() )

		return axios({
				url: `${siteData.api_base_url}votd-scheduled-recordings?date=${date}&site_id=${siteId}`,
				timeout: 20000,
				method: 'get',
				responseType: 'json'
			})
			.then( response => {
				dispatch( receiveScheduledVersesData( date, response.data ) )
			})
			.catch( error => {
				console.error( error )
			})
	}
}
